import type { ReactNode } from 'react';

import { ComboBoxDoubleLineOption } from '../../../../cdl/ComboBox/ComboBox';
import type { ComboBoxOptionComponentProps } from '../../../../cdl/ComboBox/types/ComboBoxComponentProps';
import { Tag } from '../../../../cdl/Tag/Tag';
import { translate } from '../../../helpers/translate.helper';
import { useEnums } from '../../../hooks/useEnums';
import type { ProductOption } from '../ProductOption';

export const CustomProductOption = ({ option }: ComboBoxOptionComponentProps<ProductOption>) => {
    const { getHumanReadableValue } = useEnums();

    const label = option.product.name;

    const description = `${getHumanReadableValue(
        'supplierProductGroup',
        option.product.supplierProductGroup
    )} (${getHumanReadableValue('productGroup', option.product.group)})`;

    let trailingVisual: ReactNode = null;
    if (option.suggested) {
        trailingVisual = <Tag variant="special">{translate('productSelect.suggested')}</Tag>;
    } else if (option.inTank) {
        trailingVisual = <Tag>{translate('productSelect.inTank')}</Tag>;
    }

    return <ComboBoxDoubleLineOption title={label} description={description} trailingVisual={trailingVisual} />;
};
